import { Menu } from '../models/menu.model';

export const MENU: Array<Menu> = [
  {
    icon: 'dashboard',
    route: '/app',
    title: 'Inicio',
  },
  {
    icon: 'home',
    route: '/app/houses',
    title: 'Casas',
  },
  {
    icon: 'chat',
    module: 'chatModule',
    route: '/app/chat',
    title: 'Chat',
  },
  {
    icon: 'notifications',
    route: '/app/notifications',
    title: 'Notificaciones',
  }
];